import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  ClearIcon,
  Flex,
  Input,
  Text,
  Textarea,
  TextWithIcon,
  ValidationMessage,
} from '@modusign/design-system';

interface LabelBasicInfoFormProps {
  name: string;
  description: string;
  nameErrorMessage: string;
  isDuplicated: boolean;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
}

export default function LabelBasicInfoForm({
  name,
  description,
  nameErrorMessage,
  isDuplicated,
  onDescriptionChange,
  onNameChange,
}: LabelBasicInfoFormProps) {
  return (
    <div>
      <Flex borderBottom="1px solid" borderBottomColor="dividerNeutralSlightlyLight" pb={6} px={4}>
        <Text fontWeight="medium" sx={{ flex: 'none', width: '80px' }}>
          이름
          <Text color="textNegativeBase" fontWeight="bold">
            *
          </Text>
        </Text>
        <Box flex="auto">
          <Box sx={{ position: 'relative' }} width="100%">
            <Input
              isInvalid={!!nameErrorMessage}
              maxLength={30}
              name="name"
              placeholder="30자 이하로 입력"
              sx={{
                paddingRight: 8,
              }}
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
            />
            <Box
              as="button"
              sx={{
                position: 'absolute',
                right: 3,
                top: 2,
              }}
              onClick={() => onNameChange('')}
            >
              <ClearIcon />
            </Box>
          </Box>
          {nameErrorMessage && <ValidationMessage>{nameErrorMessage}</ValidationMessage>}
          {isDuplicated && (
            <TextWithIcon
              fontSize="sm"
              leftIcon={
                <Box as={FontAwesomeIcon} color="iconPrimaryDark" icon={faExclamationCircle} />
              }
            >
              이미 같은 이름의 라벨이 있습니다.
            </TextWithIcon>
          )}
        </Box>
      </Flex>
      <Flex pt={6} px={4}>
        <Text fontWeight="medium" sx={{ flex: 'none', width: '80px' }}>
          설명
        </Text>
        <Flex flex="auto" flexDirection="column">
          <Textarea
            height="100px"
            maxLength={100}
            name="description"
            placeholder="100자 이하로 입력"
            sx={{ resize: 'none' }}
            value={description}
            width="100%"
            onChange={(e) => onDescriptionChange(e.target.value)}
          />
          <Text color="textNeutralVeryLight" fontSize="xs" mt="3px" sx={{ alignSelf: 'flex-end' }}>
            {description.length}/100
          </Text>
        </Flex>
      </Flex>
    </div>
  );
}
